import {FC} from "react";
import {Link, Outlet} from "react-router-dom";
import {Icon} from "assets/Icon";
import { OnboardingSlider } from "components/OnboardingSlider/OnboardingSlider";
import "./AuthPageLayout.scss";

export const AuthPageLayout: FC = () => (
  <div className="AuthPageLayout">
    <div className="AuthPageLayout-column-1">
      <div className="AuthPageLayout-logo">
        <Link to="/">
          <Icon name="logo3" className="autoSize"/>
        </Link>
      </div>
      <div className="AuthPageLayout-body">
        <Outlet />
      </div>
    </div> 
    <div className="AuthPageLayout-column-2">
      <OnboardingSlider/>
    </div>
  </div>
);
